import axios from "axios";

export const fetchEstimates = async (token) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/get-user-leads', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };


export const fetchEstimatesForUsers = async (token) => {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/get-estimates', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const fetchEstimatesById = async (token, id) => {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/get-estimate-detail/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const saveEstimateNotes = async (token, data) => {
  try {
    const response = await axios.post(process.env.REACT_APP_BASE_API_URL+"/save-estimate-note", data , {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


export const getEstimateNotes = async (token, id) => {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/get-estimate-notes/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};

export const updateEstimateNotes = async (token, data) => {
  try {
    const response = await axios.post(process.env.REACT_APP_BASE_API_URL+"/update-estimate-status", data , {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};


